import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { INAAction } from '../../model/ina-action';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';

import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-indicator-status',
  templateUrl: './indicator-status.component.html',
  styleUrls: ['./indicator-status.component.scss']
})



export class IndicatorStatusComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory =new EventEmitter<TrackingHistory>();
  
  frmIndicatorStatus: UntypedFormGroup;
  section: Section;
  shared: Shared ;
  notifyAction: string = '';
  inaStatusTypeId: number;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();
  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
  ) {
    this.shared=new Shared(inaService);
    this.trackHistories.inaHistory = [];

    this.frmIndicatorStatus = this.fb.group({
      radioPFS: [],
      radioAcademicRisk: [],
      radioSpecialEducation: [],
      radio504: []
    });
  }

  ngOnInit(): void {
    let sectionId: number = 20;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmIndicatorStatus.dirty) {      
        this.frmIndicatorStatus.reset();
        this.setFormValue();
      }
    });
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });


    if (this.action == INAAction.Edit) {
      this.frmIndicatorStatus.disable();
      this.radio504.enable();
      this.radio504.valueChanges.subscribe((x:any)=> {
        if(x=="1")
          this.setListQuestionValue(324, '504 plan', "True");
        else if(x=="2")
          this.setListQuestionValue(324, '504 plan', "False");        
      });
  
    }
    else if (this.action == INAAction.View) {
      this.frmIndicatorStatus.disable();
    }
  }
  setFormValue() {
    this.getQuestionValueDataRadioBtn(324, 'INDICATORS/STATUS').forEach
      (
        x => {
          if (x.Name == 'PFS' && x.Value == 'True')
            this.radioPFS.setValue("1");
          else if (x.Name == 'PFS' && (x.Value == 'False' || x.Value==''))
            this.radioPFS.setValue("2");
          else if (x.Name == 'PFS' && x.Value == '')
            this.radioPFS.setValue("");
          else if (x.Name == 'Academic Risk' && x.Value == 'True')
            this.radioAcademicRisk.setValue("1");
          else if (x.Name == 'Academic Risk' && (x.Value == 'False'|| x.Value==''))
            this.radioAcademicRisk.setValue("2");
          else if (x.Name == 'Academic Risk' && x.Value == '')
            this.radioAcademicRisk.setValue("");
          else if (x.Name == 'Special Education/IEP' && x.Value == 'True')
            this.radioSpecialEducation.setValue("1");
          else if (x.Name == 'Special Education/IEP' && (x.Value == 'False' || x.Value==''))
            this.radioSpecialEducation.setValue("2");
          else if (x.Name == 'Special Education/IEP' && x.Value == '')
            this.radioSpecialEducation.setValue("");
          else if (x.Name == '504 plan' && x.Value == 'True')
            this.radio504.setValue("1");
          else if (x.Name == '504 plan' && x.Value == 'False')
            this.radio504.setValue("2");
        }
      )
  }
  getQuestionValueDataRadioBtn(questionId: number, questionName: string): LstQuestionValueDataView[] {
    return this.shared.getListQuestionValueData(this.section, questionId, questionName);
  }

  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }

  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
    let s: StepAction = new StepAction();
    s.stepNumber = 3;
    s.action = action == 1 ? '': this.notifyAction ;
    s.section = new Section();
    if (this.frmIndicatorStatus.dirty) {
      this.updateChangeValue();
      s.section = this.section;
      s.lsttrackingHistory = this.lstTrackHistory;
      this.lstTrackHistory=[];

    }
    this.prevOrNextStep.emit(s);
  }
  */
  
 /* updateChangeValue() {
    let radioVal: string = '';
    if (this.radioPFS.dirty) {
      radioVal = this.radioPFS.value == 1 ? "True" : this.radioPFS.value == 2 ? "False" : "";
      this.setListQuestionValue(324, 'PFS', radioVal);
    }
    if (this.radioAcademicRisk.dirty) {
      radioVal = this.radioAcademicRisk.value == 1 ? "True" : this.radioAcademicRisk.value == 2 ? "False" : "";
      this.setListQuestionValue(324, 'Academic Risk', radioVal);
    }
    if (this.radioSpecialEducation.dirty) {
      radioVal = this.radioSpecialEducation.value == 1 ? "True" : this.radioSpecialEducation.value == 2 ? "False" : "";
      this.setListQuestionValue(324, 'Special Education/IEP', radioVal);
    }
    
  }*/

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);      
    }
  }


  get radioPFS(): any { return this.frmIndicatorStatus.get('radioPFS'); }
  get radioAcademicRisk(): any { return this.frmIndicatorStatus.get('radioAcademicRisk'); }
  get radioSpecialEducation(): any { return this.frmIndicatorStatus.get('radioSpecialEducation'); }
  get radio504(): any { return this.frmIndicatorStatus.get('radio504'); }
}
